<input
    type="checkbox"
    [id]="uniqueId"
    [ngClass]="!disabled ? inputClass : ''"
    [disabled]="disabled"
    [tabindex]="tabIndex"
    [indeterminate]="indeterminate"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange()"
    kendoCheckBox />

<label
    class="k-checkbox-label pl-1"
    [ngClass]="labelClass"
    [title]="title"
    for="{{ uniqueId }}"
    >{{ label }}</label
>
